import {
    GET_SPAREPART_IMPORTS_LIST_LOADING,
    GET_SPAREPART_IMPORTS_LIST,
    GET_SPAREPART_IMPORTS_LIST_ERROR,
    GET_SPAREPART_IMPORT,
    ADD_SPAREPART_IMPORT_ITEM,
    ADD_SPAREPART_IMPORT_ITEM_ERROR,
    UPDATE_SPAREPART_IMPORT_ITEM,
    UPDATE_SPAREPART_IMPORT_ITEM_ERROR,
    DELETE_SPAREPART_IMPORT_ITEM,
    DELETE_SPAREPART_IMPORT_ITEM_ERROR,
    SET_DELETE_SPAREPART_IMPORT_ITEM_ID,
    SET_UPDATE_SPAREPART_IMPORT_ITEM_ID,
    GET_SPAREPART_IMPORTS_COUNT,
    GET_SPAREPART_IMPORTS_COUNT_ERROR
} from '../actions/types';

const initialState = {
    sparepartImports: [],
    sparepartImport: null,
    loading: true,
    error: null,
    numberOfPages: 1,
    currentPage: 1,
    total_sparepart_imports: 0,
    deleteItemId: null,
    updateItemId: null,
    count: null
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_SPAREPART_IMPORTS_LIST_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_SPAREPART_IMPORTS_LIST:
            return {
                ...state,
                sparepartImports: payload.data || [],
                numberOfPages: payload.meta?.last_page || 1,
                currentPage: payload.meta?.current_page || 1,
                total_sparepart_imports: payload.meta?.total || 0,
                loading: false,
                error: null
            };

        case GET_SPAREPART_IMPORTS_LIST_ERROR:
            return {
                ...state,
                sparepartImports: [],
                loading: false,
                error: payload
            };

        case GET_SPAREPART_IMPORT:
            return {
                ...state,
                sparepartImport: payload.data || payload,
                loading: false,
                error: null
            };

        case ADD_SPAREPART_IMPORT_ITEM:
            return {
                ...state,
                sparepartImports: [payload.data, ...state.sparepartImports],
                loading: false,
                error: null
            };

        case ADD_SPAREPART_IMPORT_ITEM_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case UPDATE_SPAREPART_IMPORT_ITEM:
            return {
                ...state,
                sparepartImports: state.sparepartImports.map(item =>
                    item.id === payload.data.id ? payload.data : item
                ),
                updateItemId: null,
                loading: false,
                error: null
            };

        case UPDATE_SPAREPART_IMPORT_ITEM_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case DELETE_SPAREPART_IMPORT_ITEM:
            return {
                ...state,
                sparepartImports: state.sparepartImports.filter(item => item.id !== payload),
                deleteItemId: null,
                loading: false,
                error: null
            };

        case DELETE_SPAREPART_IMPORT_ITEM_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case SET_DELETE_SPAREPART_IMPORT_ITEM_ID:
            return {
                ...state,
                deleteItemId: payload
            };

        case SET_UPDATE_SPAREPART_IMPORT_ITEM_ID:
            return {
                ...state,
                updateItemId: payload
            };

        case GET_SPAREPART_IMPORTS_COUNT:
            return {
                ...state,
                count: payload.count,
                error: null
            };

        case GET_SPAREPART_IMPORTS_COUNT_ERROR:
            return {
                ...state,
                error: payload
            };

        default:
            return state;
    }
} 